import { api } from "../App";
import { SET_USEFUL_SITES_LIST, SET_USEFUL_SITES_BY_ID, SET_USEFUL_SITES_LOADING, GET_USEFUL_SITES_FILE } from "./types";
import { createNotification } from "../components/Notifications/Notifications";

export const getUsefulSitesList = () => async (dispatch) => {
  try {
    dispatch({ type: SET_USEFUL_SITES_LOADING, payload: true });
    const { data } = await api.get('/xp_useful_sites');
    dispatch({ type: SET_USEFUL_SITES_LIST, payload: data });
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_USEFUL_SITES_LOADING, payload: false });
  }
}

export const getUsefulSiteById = () => async (dispatch) => {
  try {
    dispatch({ type: SET_USEFUL_SITES_LOADING, payload: true });
    const { data } = await api.get('/xp_useful_sites');
    dispatch({ type: SET_USEFUL_SITES_BY_ID, payload: data });
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_USEFUL_SITES_LOADING, payload: false });
  }
}

export const createUsefulSite = (payload, filename) => async (dispatch) => {
  try {
    const { data } = await api.post('/xp_useful_sites', payload);
    await dispatch(createUsefulSiteFile(filename, data.sid));
    await dispatch(getUsefulSitesList());
  } catch (ERR) {
  }
}

export const updateUsefulSite = (payload, filename) => async (dispatch) => {
  try {
    await api.put('/xp_useful_sites', payload);
    await dispatch(getUsefulSitesList());
  } catch (ERR) {
  }
}

export const createUsefulSiteFile = (file, id) => async (dispatch) => {
  try {
    const fd = new FormData();
    fd.append("file", file);
    await api.post(`/xp_useful_sites/${id}/file`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  } catch (ERR) {
  }
};

export const getUsefulSitesFile = (id) => async (dispatch) => {
  try {
    const response = await api.get(`/xp_useful_sites/${id}/file`, {
      responseType: 'blob'
    });
    const objectURL = URL.createObjectURL(response.data);
    dispatch({ type: GET_USEFUL_SITES_FILE, payload: objectURL });
  } catch (ERR) {
    dispatch({ type: GET_USEFUL_SITES_FILE, payload: null });
  }
};
